import React from 'react';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";
import {connect} from "trim-redux";
import SubTitle from "./SubTitle";
import {Card, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

const SystemBankInfo = ({setting}) => {
    const { t } = useTranslation();

    return (
        <Card style={{padding:20}}>
            <SubTitle align="left">{t('systemBankInfo')}</SubTitle>
            <Typography>{t('systemBankInfoDesc')}</Typography>
            <Typography>
                <span>{t('accountName')}: </span> <strong>{setting.system_account_name}</strong>
            </Typography>
            <Typography>
                <span>{t('accountIBAN')}: </span> <strong>{setting.system_iban}</strong>
            </Typography>
        </Card>
    );
};
const mstp = state => ({
    setting: state.setting,
});
export default withStyles(Styles)(connect(mstp)(SystemBankInfo));
